import { createReducer } from 'src/helpers/reducer';
import { ISendRequestParams } from '@dash/actions';
import actionsTypes from './actionTypes';
import { IChangeModalVisibilityPayload, IProcessActionSuccessPayload, IViewSkillModalState } from './types';

const initState: IViewSkillModalState = {
  isLoading: false,
  isModalVisible: false,
  positionDetails: {
    position: undefined,
    status: undefined,
    created_at: undefined,
    assessment: undefined,
    experiences: undefined,
    actions: undefined,
  },
  skill: null,
  isPositionDetailsLoading: false,
  type: undefined,
  isApproveActionLoading: false,
  isDenyActionLoading: false,
  skillDetails: undefined,
  isLandingPage: false,
  loadSkillsQuery: undefined,
};

function onChangeModalVisibility(state: IViewSkillModalState, { payload }: { payload: IChangeModalVisibilityPayload }) {
  const { skill, type, isLandingPage, loadSkillsQuery } = payload;

  return {
    ...state,
    isModalVisible: !state.isModalVisible,
    skill,
    type,
    isLandingPage: isLandingPage || false,
    loadSkillsQuery,
  };
}

function onProcessActionRequest(state: IViewSkillModalState, { payload }: { payload: ISendRequestParams }) {
  return {
    ...state,
    isLoading: true,
    isApproveActionLoading: payload.key === 'approve' ? true : state.isApproveActionLoading,
    isDenyActionLoading: payload.key === 'deny' ? true : state.isDenyActionLoading,
  };
}

function onProcessActionSuccess(state: IViewSkillModalState, { payload }: { payload: IProcessActionSuccessPayload }) {
  return {
    ...state,
    isLoading: false,
    isApproveActionLoading: false,
    isDenyActionLoading: false,
    skillDetails: payload?.key === 'view_skill' ? payload.skillDetails : state.skillDetails,
  };
}

function onProcessActionError(state: IViewSkillModalState) {
  return {
    ...state,
    isLoading: false,
    isApproveActionLoading: false,
    isDenyActionLoading: false,
  };
}

function onClearState() {
  return {
    ...initState,
  };
}

export default createReducer(initState, {
  [actionsTypes.CHANGE_MODAL_VISIBILITY]: onChangeModalVisibility,
  [actionsTypes.PROCESS_ACTION_REQUEST]: onProcessActionRequest,
  [actionsTypes.PROCESS_ACTION_SUCCESS]: onProcessActionSuccess,
  [actionsTypes.PROCESS_ACTION_ERROR]: onProcessActionError,
  [actionsTypes.CLEAR_STATE]: onClearState,
});
